import baseURL from "../common/axios";

class LeadService {
  //To Insert Leads-->MOPCRM API
  create(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Leads/Create", dataModel);
  }

  createCustom(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Leads/CreateCustom", dataModel);
  }
  //To Update Leads-->MOPCRM API
  update(dataModel) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post("Leads/Update", dataModel);
  }
  //To updateAgent Leads-->MOPCRM API
  updateAgent(Id, agentId) {
    return baseURL.httpMSMOPCRMUrl.put(
      "Leads/AssignUpdate?Id=" + Id + "&AssignTo=" + agentId
    );
  }
  //To Delete Leads-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("Leads/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "Leads/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get Leads List-->MOPCRM API
  getList() {
    return baseURL.httpMSMOPCRMUrl.get("Leads/List");
  }

  getListCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption,
    ClientId
  ) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Leads/ListCustom?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      "&ClientId=" +
      ClientId +
      ""
    );
  }

  getListCustomByPhoneNo(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption
  ) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Leads/ListCustomByPhoneNo?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }

  //To Get Leads List-->MOPCRM API
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Leads/Get?id=" + Id + "");
  }

  updateLeadStatus(Id, LStatusId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.put(
      "Leads/LeadStatusUpdate?Id=" + Id + "&LStatusId=" + LStatusId
    );
  }

  getLeadDashboardListCustom(branch, agentid, admin, clientId) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Leads/GetLeadDashboardCustom?branch=" +
      branch +
      "&agentid=" +
      agentid +
      "&admin=" +
      admin +
      "&clientId=" +
      clientId
    );
  }

  GetLeadDashboardStats(clientId, branch, agentid, admin, flag) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Leads/GetLeadDashboardStats?clientId=" +
      clientId +
      "&branchId=" +
      branch +
      "&assignTo=" +
      agentid +
      "&admin=" +
      admin +
      "&flag=" +
      flag
    );
  }

  DashboardList() {
    return baseURL.httpMSMOPCRMUrl.get("Leads/DashboardList");
  }

  getServicePipeLineListCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption
  ) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Leads/ListServicePipeLineCustom?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }
}
export default new LeadService();
